import type { Command, CommandContext } from "./Command";

export class RestartCommand implements Command {
  execute(context: CommandContext): void {
    context.events.emit("game:restart", {});
  }
}
